import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Spin, Descriptions, message, Layout } from 'antd';
import { ArrowLeftOutlined, DownloadOutlined, EditOutlined } from '@ant-design/icons';
import { posters, proxyImageUrl, downloadImageFile } from '../../api';

const { Content } = Layout;

function PosterDetail() {
  const { posterUuid } = useParams();
  const navigate = useNavigate();
  const [poster, setPoster] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPoster();
  }, [posterUuid]);

  const fetchPoster = async () => {
    try {
      const res = await posters.detail(posterUuid);
      setPoster(res.data.data);
    } catch (err) {
      message.error('获取海报详情失败');
    }
    setLoading(false);
  };

  const handleDownload = async () => {
    try {
      await downloadImageFile(poster.image_url, poster.title);
    } catch (err) {
      message.error(err.message || '下载失败');
    }
  };

  const handleEdit = () => {
    window.open(`https://imgedit.zl6.cn/?posterUuid=${encodeURIComponent(poster.uuid || posterUuid)}`, '_blank', 'noopener,noreferrer');
  };

  if (loading) {
    return <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />;
  }

  if (!poster) {
    return <div style={{ textAlign: 'center', padding: 50 }}>海报不存在</div>;
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Content style={{ padding: 24, maxWidth: 1200, margin: '0 auto' }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)} style={{ marginBottom: 16 }}>
          返回
        </Button>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 300px', gap: 24 }}>
          <div>
            <img 
              src={proxyImageUrl(poster.image_url)} 
              alt={poster.title} 
              style={{ width: '100%', borderRadius: 8 }}
            />
          </div>
          
          <div>
            <h1>{poster.title}</h1>
            <p style={{ color: '#666' }}>{poster.description}</p>
            
            <Descriptions column={1} bordered style={{ marginBottom: 24 }}>
              <Descriptions.Item label="分类">{poster.category_name || '-'}</Descriptions.Item>
              <Descriptions.Item label="标签">{poster.tag_names || '-'}</Descriptions.Item>
              <Descriptions.Item label="创建时间">{poster.created_at}</Descriptions.Item>
            </Descriptions>
            
            <div style={{ display: 'flex', gap: 12 }}>
              <Button type="primary" icon={<DownloadOutlined />} onClick={handleDownload} size="large">
                下载海报
              </Button>
              <Button icon={<EditOutlined />} onClick={handleEdit} size="large">
                在线编辑
              </Button>
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
}

export default PosterDetail;
